exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-content-half .el-form-item__content{max-width:50%}.form-panel{margin:20px 0 0}", "", {"version":3,"sources":["/workspace/src/views/audit-task-setting/pages/AuditTaskSettingFormPage.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD,AACD,YAAY,eAAe,CAC1B","file":"AuditTaskSettingFormPage.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n.form-panel{margin:20px 0 0\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a8f68a7","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/audit-task-setting/pages/AuditTaskSettingFormPage.vue
// module id = 3268
// module chunks = 59